import * as React from 'react';
import { SVGProps } from 'react';

const IconDocBlankSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.414a1 1 0 0 0-.293-.707l-5.414-5.414A1 1 0 0 0 13.586 2H6zm8 7a1 1 0 0 1-1-1V3.5L18.5 9H14z" />
  </svg>
);
export default IconDocBlankSizeM;
